import { render, staticRenderFns } from "./CreateOwn.vue?vue&type=template&id=73c80590"
import script from "./CreateOwn.vue?vue&type=script&lang=js"
export * from "./CreateOwn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports